import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgSwe = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: "1em",
	height: "1em",
	viewBox: "0 0 17 17",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("mask", {
		id: "mask0_9162_14621",
		style: { maskType: "alpha" },
		maskUnits: "userSpaceOnUse",
		x: 0,
		y: 0,
		width: 17,
		height: 17,
		children: /* @__PURE__ */ _jsx("circle", {
			cx: 8.5,
			cy: 8.5,
			r: 8.5,
			fill: "#D9D9D9"
		})
	}), /* @__PURE__ */ _jsxs("g", {
		mask: "url(#mask0_9162_14621)",
		children: [/* @__PURE__ */ _jsx("path", {
			d: "M-2 0.000207515H24V17H-2V0.000207515Z",
			fill: "#0052B4"
		}), /* @__PURE__ */ _jsx("path", {
			d: "M7.75 0H4.5V6.90606H-2V10.0935H4.5V16.9995H7.75V10.0935H24V6.90606H7.75V0Z",
			fill: "#FFDA44"
		})]
	})]
});
export default SvgSwe;
